import { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { fade, makeStyles } from '@material-ui/core/styles'
import InputBase from '@material-ui/core/InputBase'
import SearchIcon from '@material-ui/icons/Search'
import { useDebounce } from '../../../utils/useDebouceHook'
import { setSearchTerm } from '../../../redux/slices/common'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  login: {
    // textAlign: "right"
  },
  navButton: {
    // textAlign: "left"
  },
  languageIcon: {
    marginRight: theme.spacing(0.5),
  },
  languageCheckIcon: {
    marginLeft: theme.spacing(0.5),
    color: theme.palette.success.dark,
  },
  accountIcon: {
    marginLeft: theme.spacing(0.5),
  },
  companySettingsModalContent: {
    backgroundColor: theme.palette.background.paper,
    border: '1px solid #000',
    boxShadow: theme.shadows[1],
    maxHeight: '80%',
    maxWidth: '80%',
    overflowY: 'scroll',
  },
  companySettingsModal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  iconImage: {
    flexGrow: 1,
  },
  logoImage: {
    height: '40px',
    width: '160px',
    [theme.breakpoints.down('md')]: {
      height: '30px',
      width: '120px',
    },
    [theme.breakpoints.down('md')]: {
      height: '20px',
      width: '80px',
    },
    [theme.breakpoints.down('xs')]: {
      height: '10px',
      width: '40px',
    },
  },
  userProfileModalContent: {
    backgroundColor: theme.palette.background.paper,
    border: '1px solid #000',
    boxShadow: theme.shadows[1],
  },
  userProfileModal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '75%',
  },
  changePasswordModalContent: {
    backgroundColor: theme.palette.background.paper,
    border: '1px solid #000',
    boxShadow: theme.shadows[1],
  },
  changePasswordModal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '50%',
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1),
      width: 'auto',
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '12ch',
      '&:focus': {
        width: '20ch',
      },
    },
  },
}))

function SearchBar() {
  const classes = useStyles()
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [searchValue, setSearchValue] = useState('')
  const currentUrl = window.location.href
  const invokeSearchDebounce = useDebounce(() => {
    dispatch(setSearchTerm(searchValue))
  }, 400)

  const handleNavbarSearchTermChange = searchTerm => {
    setSearchValue(searchTerm)
  }

  useEffect(() => {
    setSearchValue('')
  }, [currentUrl])

  useEffect(() => {
    invokeSearchDebounce()
  }, [searchValue])

  return (
    <div className={classes.search}>
      <div className={classes.searchIcon}>
        <SearchIcon />
      </div>
      <InputBase
        value={searchValue}
        placeholder={`${t('SearchBar:searchLabel')}...`}
        classes={{
          root: classes.inputRoot,
          input: classes.inputInput,
        }}
        inputProps={{ 'aria-label': 'search' }}
        onChange={e => handleNavbarSearchTermChange(e.target.value)}
      />
    </div>
  )
}

export default SearchBar
